import { httpClient } from 'core';

const deleteUser = async (): Promise<string> => {
  return await httpClient.delete('/user');
};

export default {
  deleteUser,
};
